import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';



(function () {
    if (
        // No Reflect, no classes, no need for shim because native custom elements
        // require ES2015 classes or Reflect.
        window.Reflect === undefined ||
        window.customElements === undefined ||
        // The webcomponentsjs custom elements polyfill doesn't require
        // ES2015-compatible construction (`super()` or `Reflect.construct`).
        window.customElements.hasOwnProperty('polyfillWrapFlushCallback')
    ) {
        return;
    }
    const BuiltInHTMLElement = HTMLElement;
    window.HTMLElement = /** @this {!Object} */ function HTMLElement() {
        return Reflect.construct(
            BuiltInHTMLElement, [], /** @type {!Function} */ (this.constructor));
    };
    HTMLElement.prototype = BuiltInHTMLElement.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();

const mountPoint = document.createElement('span');
const attributes = ['footertext', 
                    'headertext', 
                    'maintext', 
                    'popoverheader', 
                    'position', 
                    'logosrc', 
                    'popovertext',
                    'accentcolor',
                    'secondarycolor', 
                    'goodbyetext', 
                    'startinghour', 
                    'endinghour',
                    'skipweekends',
                    'phonefield', 
                    'datefield', 
                    'campaignid',
                    'apiaddress',
                    'workinghourstext'];
function renderWithAttributes(context) {
    let values = {};
    for(var i = 0; i < attributes.length; i++){
        let attribute = context.getAttribute(attributes[i]); 
        values[attributes[i]] = attribute;
    }    

    context.appendChild(mountPoint);
    ReactDOM.render( < App {...values}
        />, mountPoint);
    }
    customElements.define('alfa-call-request', class PromptManagerComponent extends HTMLElement {

        static get observedAttributes() {
            return attributes;
        }

        connectedCallback() {
            this.id = "alfaCallRequestShadow";
            renderWithAttributes(this);
        }


        attributeChangedCallback(name, oldValue, newValue) {
            renderWithAttributes(this);
        }
    });


    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();